var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7454 3.25637C8.40357 2.91454 7.84936 2.91454 7.50753 3.25637L4.18812 6.57577C4.18473 6.57909 4.18137 6.58245 4.17806 6.58584L4.14758 6.61632L4.14897 6.61771C4.05603 6.72684 3.99994 6.86831 3.99994 7.02288C3.99994 7.36818 4.27986 7.6481 4.62516 7.6481C4.77973 7.6481 4.9212 7.59201 5.03033 7.49907L5.03177 7.50052L7.50124 5.03105V12.3748C7.50124 12.7201 7.78116 13 8.12646 13C8.47177 13 8.75169 12.7201 8.75169 12.3748V5.03105L11.2212 7.50052L11.2226 7.49907C11.3317 7.59201 11.4732 7.6481 11.6278 7.6481C11.9731 7.6481 12.253 7.36818 12.253 7.02288C12.253 6.86831 12.1969 6.72684 12.104 6.61771L12.1054 6.61632L12.0749 6.58585L12.0648 6.57577L8.7454 3.25637Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.92ecf70fb61c8192c584ca05089aef78.svg";
export { ForwardRef as ReactComponent };